export type IAllType = string | number | boolean | null | undefined | { [props: string]: string } | any;

export const setStorage = (
	key: string,
	value: IAllType | IAllType[],
	type?: 'session' | 'locale',
) => {
	const setType = type ?? 'locale';

	const valueString = JSON.stringify(value);

	setType === 'session' && sessionStorage.setItem(key, valueString);
	setType === 'locale' && localStorage.setItem(key, valueString);
};

export const getStorage = (key: string) => {
	if (sessionStorage.getItem(key) || localStorage.getItem(key)) {
		if ((sessionStorage.getItem(key) || localStorage.getItem(key)) === 'undefined') {
			return undefined;
		}
		return JSON.parse(sessionStorage.getItem(key) || (localStorage.getItem(key) as string));
	}
	return null;
};

export const removeStorage = (key: string) => {
	if (sessionStorage.getItem(key)) {
		sessionStorage.removeItem(key);
	}

	if (localStorage.getItem(key)) {
		localStorage.removeItem(key);
	}
};

export const clearStorage = (type?: 'session' | 'locale') => {
	sessionStorage.clear();
	localStorage.clear();
};
